/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Flex, Form, Input, Splitter } from 'antd';
import Modal from 'components/modal';
import { authProfile } from 'redux/auth/selectors';
import GoogleMap from 'routes/app/zone/components/map/GoogleMap';
import Card from 'components/card';
import { useCreateGroupingZone, useZones, Zone } from 'services/ZoneService';
import useUserCityPosition from 'hooks/useUserCity';
import { ChildrenZonesSelector } from './components/childrenZonesSelector';

const { TextArea } = Input;

const GroupingZoneAdd = () => {
  const history = useHistory();
  const profile = useSelector(authProfile);
  const { lat, lng } = useUserCityPosition();
  const {
    zones: { data: zones, isSuccess, isLoading, isFetching },
  } = useZones();
  const { mutate: createGroupingZone } = useCreateGroupingZone();

  const [name, setName] = useState<string>();
  const [detail, setDetail] = useState<string>();
  const [open, setOpen] = useState(false);
  const [childrenZonesIds, setChildrenZonesIds] = useState<
    (number | undefined)[]
  >([]);

  const childrenZones = useMemo(
    () => zones.filter((z: Zone) => !!z.id && childrenZonesIds.includes(z.id)),
    [childrenZonesIds, zones],
  );

  if (!isSuccess) return history.push('/zones');

  const handleSubmit = () => {
    const tenant = profile?.tenantId;
    const logisticOperatorId = profile?.logisticOperatorID;

    const zone: Zone = {
      name,
      detail,
      tenant,
      logisticOperatorId,
      childrenZones: childrenZonesIds,
    };

    createGroupingZone(zone);
    history.goBack();
  };

  return (
    <>
      <Modal
        title={`¿Confirmar creación de zona agrupadora ${name}?`}
        okText="Confirmar"
        cancelText="Volver"
        onOk={handleSubmit}
        onCancel={() => setOpen(false)}
        open={open}
      />
      <Splitter style={{ height: '83vh' }}>
        <Splitter.Panel
          style={{
            scrollbarGutter: 'stable',
            scrollbarColor: 'lightgrey transparent',
            overflowX: 'hidden',
          }}
        >
          <Flex
            vertical
            style={{
              padding: '0 4px 0 0',
              height: '100%',
            }}
          >
            <Card title="Datos de la zona">
              <label>Nombre:</label>
              <Form.Item validateStatus="warning">
                <Input
                  placeholder="Nombre"
                  onBlur={(event) => setName(event.target.value)}
                  onPressEnter={({ target }) => {
                    setName((target as HTMLInputElement).value);
                  }}
                />
              </Form.Item>
              <label>Descripción:</label>
              <Form.Item validateStatus="warning">
                <TextArea
                  rows={6}
                  placeholder="Informacion adicional de esa zona"
                  onBlur={(event) => setDetail(event.target.value)}
                  onPressEnter={({ target }) => {
                    setDetail((target as HTMLInputElement).value);
                  }}
                />
              </Form.Item>
            </Card>
            <ChildrenZonesSelector
              selectedChildrenZones={childrenZones}
              setChildrenZonesIds={setChildrenZonesIds}
            />
          </Flex>
        </Splitter.Panel>
        <Splitter.Panel defaultSize="70%" min="50%" max="80%">
          <div style={{ width: '100%', height: '100%', padding: '0 0 0 14px' }}>
            <GoogleMap
              arePolygonsLoading={isLoading || isFetching}
              initialCenter={{
                lat: lat ?? -34.601692,
                lng: lng ?? -58.431461,
              }}
              polygons={childrenZones}
            />
          </div>
        </Splitter.Panel>
      </Splitter>
      <Button
        type="primary"
        onClick={() => setOpen(true)}
        disabled={!name || !detail || childrenZonesIds.length < 1}
        size="large"
        style={{
          position: 'absolute',
          bottom: 0,
          right: 0,
          marginRight: 80,
          marginBottom: 40,
        }}
      >
        Crear nueva Zona agrupadora
      </Button>
    </>
  );
};

export default GroupingZoneAdd;
